import {ErrorBlock} from "~/components/ErrorBlocks/ErrorBlock";
import {Button, SvgIcon} from "@mui/material";
import {useHistory} from "react-router-dom";


export const NotFound = () => {
    const history = useHistory();

    const handleButtonClick = () => {
        history.push("/");
    }

    return (
        <ErrorBlock
            title="Ошибка 404"
            icon={(
                <SvgIcon width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path fillRule="evenodd" clipRule="evenodd" d="M18 27C22.9706 27 27 22.9706 27 18C27 13.0294 22.9706 9 18 9C13.0294 9 9 13.0294 9 18C9 22.9706 13.0294 27 18 27ZM18 29C24.0751 29 29 24.0751 29 18C29 11.9249 24.0751 7 18 7C11.9249 7 7 11.9249 7 18C7 24.0751 11.9249 29 18 29ZM27.7071 27.2929L33.7071 33.2929C34.0976 33.6834 34.0976 34.3166 33.7071 34.7071C33.3166 35.0976 32.6834 35.0976 32.2929 34.7071L26.2929 28.7071C25.9024 28.3166 25.9024 27.6834 26.2929 27.2929C26.6834 26.9024 27.3166 26.9024 27.7071 27.2929ZM14.7071 13.2929C14.3166 12.9024 13.6834 12.9024 13.2929 13.2929C12.9024 13.6834 12.9024 14.3166 13.2929 14.7071L16.5858 18L13.2929 21.2929C12.9024 21.6834 12.9024 22.3166 13.2929 22.7071C13.6834 23.0976 14.3166 23.0976 14.7071 22.7071L18 19.4142L21.2929 22.7071C21.6834 23.0976 22.3166 23.0976 22.7071 22.7071C23.0976 22.3166 23.0976 21.6834 22.7071 21.2929L19.4142 18L22.7071 14.7071C23.0976 14.3166 23.0976 13.6834 22.7071 13.2929C22.3166 12.9024 21.6834 12.9024 21.2929 13.2929L18 16.5858L14.7071 13.2929Z" fill="#6E798C"/>
                </SvgIcon>
            )}
            button={(
                <Button onClick={handleButtonClick}>
                    Перейти на главную
                </Button>
            )}
        >
            Страница не найдена, либо ещё не создана
        </ErrorBlock>
    )
}